import { Builder } from '@builder.io/react'
import React, { useEffect, useState } from 'react'

const InstagramGrid = () => {
  const [mediaUrls, setMediaUrls] = useState<string[]>([])

  useEffect(() => {
    console.log('init...')
    const fetchInstaData = async () => {
      const data = await fetch(
        `https://cdn.builder.io/api/v1/instagram/media?apiKey=${
          process.env.GATSBY_BUILDERIO_KEY || process.env.BUILDERIO_KEY
        }`
      )
      const jsonData = await data.json()
      console.log('Instagram Data', jsonData)
      const urls: any[] = jsonData.data.map((mediaItem: any) => {
        return mediaItem.media_url
      })
      setMediaUrls([...urls])
    }

    fetchInstaData()
  }, [])

  const renderMediaUrls = () => {
    return mediaUrls.map(url => {
      return (
        <li key={url} className="relative">
          <div className="group aspect-w-10 aspect-h-7 block w-full overflow-hidden bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
            <img src={url} alt="" className="pointer-events-none object-cover group-hover:opacity-75" />
          </div>
        </li>
      )
    })
  }

  return (
    <div className="w-full p-4">
      <div className="container mx-auto">
        <ul role="list" className="sm:grid-cols-3lg:grid-cols-4 grid grid-cols-2">
          {renderMediaUrls()}
        </ul>
      </div>
    </div>
  )
}

export default InstagramGrid

Builder.registerComponent(InstagramGrid, {
  name: 'InstagramGrid',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    }
  ]
})
